export default "__VITE_ASSET__DwUfKLa$__"